import * as types from './types'

export const reloadTranslations = () => ({
  type: [types.RELOAD_TRANSLATIONS, types.RELOAD_TRANSLATIONS_SUCCESS, types.RELOAD_TRANSLATIONS_FAILED],
  payload: {
    api: 'support',
    request: {
      method: 'GET',
      url: '/modules/translations/reload'
    }
  }
})
